import { useState , useEffect} from 'react';
import axios from 'axios';

export const useFetchBarrierFrees = () => {
    const [dataList, setDataList] = useState([]);
    const [isLoading , setIsLoading] = useState(false);
    //const [isError , setIsError] = useState(false);
    
    useEffect(() => {
        const fetchRequest = async ()  =>{
            setIsLoading(true);
            //setIsError(false);

            //JSON取得
            axios.get('/assets/json/barrierFreeData.json?20250713')
                .then(res => {
                    const data = JSON.parse(JSON.stringify(res.data));
                    setDataList(data.list);
                })
                //.catch(() => setIsError(true))
                .finally(() => setIsLoading(false));
        }
        fetchRequest();
    }, []); 

    return {dataList , isLoading };
}
